import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'

import moment from 'moment'
import VueTippy, { TippyComponent } from 'vue-tippy'

import '@/vendor/jquery.min.js'
import '@/vendor/bootstrap/js/dist/util.js'
import '@/vendor/bootstrap/js/dist/modal.js'
import 'tippy.js/themes/light-border.css'

Vue.config.devtools = document.domain === 'ohm.dev.opoint.com'
Vue.config.productionTip = false

Vue.use(VueTippy, {
  arrow: true,
  animation: 'fade',
  theme: 'light-border',
  // trigger: 'click',
  onShow: (options) => {
    // Don't show tooltip if content is empty/null
    return !!options.props.content
  },
})
Vue.component('tippy', TippyComponent)

// Set up Vue template filters
Vue.filter('formatDate', (val, format = 'MMM Do YYYY HH:mm') => {
  if (!val) {
    return ''
  }
  return moment.unix(val).format(format)
})
Vue.filter('formatRelative', (val) => {
  if (!val) {
    return ''
  }
  return moment.unix(val).fromNow()
})
Vue.filter('capitalize', (val) => {
  val = val.toString()
  if (!val) {
    return ''
  }
  return val.charAt(0).toUpperCase() + val.slice(1)
})
Vue.filter('prettify', (val) => {
  if (!val) {
    return ''
  }
  return JSON.stringify(val, null, '\t')
})
Vue.filter('getHintName', (linkfilter) => {
  let name = ''
  switch (linkfilter.t_id_type) {
    case 1:
      switch (linkfilter.t_id_source) {
        case -1:
          name = "Section-section"
          break
        case 0:
          name = "Section-site"
          break
        default:
          name = "Section"
          break
      }
      break
    case 2:
      name = "Promoted link"
      break
    case 6:
      name = "Hint"
      break
    default:
      name = "Unknown"
      break
  }
  return name
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
